import { isDefined } from '@aloft/toolkit-shared';

import { CompSelectionProperty } from '../types.js';

export const isWithinDistanceMiles = (distanceMiles: number) => (comp: CompSelectionProperty) => {
  return isDefined(comp.distanceToSubject) && comp.distanceToSubject <= distanceMiles;
};
